import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useDeleteBrandGroupMutation } from '../hooks/useDeleteBrandGroupMutation'

export const DeleteBrandGroupDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { brandGroup } = dialogInfo

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const deleteBrandGroupMutation = useDeleteBrandGroupMutation({
    onSuccess: closeDialogWithRefresh,
  })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    deleteBrandGroupMutation.mutate(brandGroup.id)
  }, [brandGroup.id, deleteBrandGroupMutation])

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  return (
    <ExecuteCancelDialog
      executing={deleteBrandGroupMutation.isPending}
      mode="delete"
      title={t('delete_brand_group')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_confirmation', { target: brandGroup.name })}
    </ExecuteCancelDialog>
  )
}
